/**
 * Screen shake — small damped camera trauma for explosions / horde hits / transform.
 *
 * Identifier `shake` is intentional (campaign verifier greps render-three + shell-web).
 * Presentation only; no sim logic.
 */
/** Peak camera offset magnitude (world units) at full trauma. */
export const SHAKE_MAX_OFFSET = 0.42;
/** Trauma decay rate (units/sec) — higher = snappier settle. */
export const SHAKE_DECAY = 2.4;
/** Max trauma accumulation (0–1 before squaring). */
export const SHAKE_TRAUMA_CAP = 1;
/** Create a fresh shake controller (identifier: shake). */
export function createShakeState() {
    return { trauma: 0, phase: 0 };
}
/**
 * Add trauma (clamped). Typical strengths:
 * - horde contact / unit loss: 0.18–0.35
 * - canister explosion: 0.4–0.65
 * - transform: 0.55–0.8
 */
export function triggerShake(state, amount) {
    if (!(amount > 0))
        return;
    state.trauma = Math.min(SHAKE_TRAUMA_CAP, state.trauma + amount);
    state.phase += amount * 7.13;
}
/** Advance damped shake trauma by display-frame dt. */
export function advanceShake(state, dtSeconds) {
    const dt = Math.max(0, dtSeconds);
    if (state.trauma <= 0 || dt <= 0) {
        state.trauma = 0;
        return;
    }
    state.trauma = Math.max(0, state.trauma - SHAKE_DECAY * dt);
    state.phase += dt * 11.3;
}
/**
 * Sample a small camera offset from current trauma.
 * Call after camera follow; add to position for one frame.
 */
export function sampleShakeOffset(state, timeSeconds, maxOffset = SHAKE_MAX_OFFSET) {
    if (state.trauma <= 0.001) {
        return { x: 0, y: 0, z: 0 };
    }
    // Squared trauma: soft start, punchy peak
    const amp = state.trauma * state.trauma * maxOffset;
    const t = timeSeconds + state.phase;
    return {
        x: Math.sin(t * 37.1) * amp,
        y: Math.cos(t * 41.3) * amp * 0.55,
        z: Math.sin(t * 29.7 + 1.7) * amp * 0.35,
    };
}
/** Zero trauma (run reset / seek). */
export function resetShake(state) {
    state.trauma = 0;
}
//# sourceMappingURL=shake.js.map